import { defineStore } from 'pinia'
import http from '@/http'

export const useFiltersStore = defineStore('filters', {
  state: () => ({
    clients: [],
    warehouses: [],
    statuses: [],
    isLoaded: false,
    loading: false
  }),

  getters: {
    getClientById: (state) => (id) => {
      return state.clients.find(client => client.id === id)
    },
    getWarehouseById: (state) => (id) => {
      return state.warehouses.find(warehouse => warehouse.id === id)
    },
    getStatusName: () => (status) => {
      // Можно добавить маппинг статусов на читаемые названия
      const statusMap = {
        'all': "Все заказы",
        'planned': 'Запланирован',
        'driving_to_load': 'Ожидает погрузку',
        'started_loading': 'На погрузке',
        'finished_loading': 'В пути',
        'is_delivered': 'Доставлен'
      }
      return statusMap[status] || status
    }
  },

  actions: {
    async fetchFilters() {
      if (this.isLoaded && !this.loading) {
        return // Данные уже загружены
      }

      try {
        this.loading = true
        const response = await http.get('/api/dispatcher/filters')
        
        if (response.data && response.status === 200) {
          // console.log('Filters fetched successfully:', response.data)
          this.clients = response.data.order.clients || []
          this.warehouses = response.data.order.warehouses || []
          this.statuses = response.data.order.statuses || []
          this.isLoaded = true
        }
      } catch (error) {
        console.error('Error fetching filters:', error)
      } finally {
        this.loading = false
      }
    },

    clearFilters() {
      this.clients = []
      this.warehouses = []
      this.statuses = []
      this.isLoaded = false
    }
  }
})